import React, { ComponentProps } from "react";

const FooterButton = ({
  children,
  className,
  ...props
}: ComponentProps<"button">) => {
  return (
    <button
      className={`relative w-full h-full font-sans overflow-hidden text-sm p-2 bg-[#1A1A1C]
      border border-[#ffffff1a] hover:border-white ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default FooterButton;
